/*
 * @Descripttion : 考试管理API
 * @Author       : pishengjun
 * @Date         : 2021-08-11 10:49:57
 */

import axios from "@/utils/request";
import { RequestEnum, ServiceGateWay } from "@/utils/enum";

const EXAM = `${ServiceGateWay.EXAM}`;
const TEMPLATE = `${ServiceGateWay.TEMPLATE}/examinee`;
const FILEDINFO = `${ServiceGateWay.FILEDINFO}`;
const EXAMINEE = `${ServiceGateWay.EXAMINEE}`;
const ORGANIZATION = `${ServiceGateWay.ORGANIZATION}`;
const DICTIONARYAPI = `${ServiceGateWay.DICTIONARY}`;
const subject = `${ServiceGateWay.SUBJECT}`;
const SCOREQUERYSERVICE = `${ServiceGateWay.SCOREQUERYSERVICE}`;
import qs from "qs";
import type {
  ExamCode,
  ExamDetailModel,
  ExamListInfoModel,
  ExamParamsResponse,
  ExamSite,
  ExamineeDetailByIdCard,
  ExamineeQueryScoreData,
  ExamineeScoreQuerySetting,
  ParticipateExamsModel,
  TemplateDetail,
} from "../interfaceModel/exam";
import { store } from "@/store";
import type { AxiosResponse } from "axios";

// * 考生管理相关
const ExamInfo = {
  GET: {
    // 考生端获取当前考试设置 ExamineeExamSetting
    async getExamineeExamSetting(tenantId: string) {
      // const storeValue = store.state.userOperationExamMap[tenantId]?.examScoreQuerySetting;
      const examScoreQuerySetting = await axios<ExamineeScoreQuerySetting>({ url: `${SCOREQUERYSERVICE}/ExamineeScoreQuerySetting`, options: { tenantId: tenantId } });
      // if (!storeValue) {
      //   store.commit("SET_USER_OPERATION_EXAMMAP", {
      //     tenantId: tenantId,
      //     data: { examScoreQuerySetting: examScoreQuerySetting },
      //   });
      // }
      return examScoreQuerySetting;
    },
    // 根据ID获取考试详情
    async getExamById(tenantId: string): Promise<ExamDetailModel> {
      const examDetail = await axios<ExamDetailModel>({ url: `${EXAM}/ExamineeExam/${tenantId}` });
      store.commit("SET_USER_OPERATION_EXAMMAP", {
        tenantId: tenantId,
        data: { examDetail: examDetail },
      });
      return examDetail;
    },
    // 获取考试列表
    async getExamList(params: any): Promise<ExamParamsResponse> {
      const response = await axios<ExamParamsResponse>({ url: `${EXAM}/ExamineeExam`, params, method: RequestEnum.GET });
      if (response.result.length) {
        response.result.forEach((examDetail: ExamDetailModel) => {
          const tenantId = examDetail.id;
          store.commit("SET_USER_OPERATION_EXAMMAP", {
            tenantId: tenantId,
            data: { examDetail: examDetail },
          });
        });
        // 存储examListIds
        const examListIds = response.result.map((item) => item.id);
        store.commit("SET_DATA", { name: "examListIds", data: examListIds });
      }
      return response;
    },
    async getRealNameLevelVerify(tenantId: string): Promise<AxiosResponse<Boolean>> {
      const res = await axios<AxiosResponse<Boolean>>({
        url: `${EXAM}/ExamineeExam/RealNameLevelVerify/?examId=${tenantId}`,
        method: RequestEnum.GET,
        options: {
          isReturnResponse: true,
          isShowError: false,
          tenantId,
        },
      });
      return res;
    },
    // 根据身份证ID获取考生数据
    getExamineeDetailByIdCard: (idCard: string, tenantId: string) => {
      return axios<ExamineeDetailByIdCard>({
        url: `${EXAMINEE}/ExamineeExtremityExamineeService/IdCard/${idCard}`,
        options: {
          tenantId,
        },
      });
    },
    // 根据当前ID获取模板详情
    getMyTemplate: (id: any, tenantId: string) => {
      return axios<TemplateDetail>({
        url: `${TEMPLATE}/template/${id}`,
        method: RequestEnum.GET,
        options: {
          noTransform: true,
          tenantId,
        },
      });
    },
    // 获取当前考试下面所有职位
    getAllPositions: (tenantId: string, params?: any) => {
      const data = qs.stringify(params, { arrayFormat: "repeat" });
      return axios({
        url: `${ORGANIZATION}/examinee/Position/Query?${data}`,
        options: {
          noTransform: true,
          tenantId,
        },
      });
    },
    // 获取所有机构
    getAllOrg: (tenantId: string, params?: any) => {
      return axios({
        url: `${ORGANIZATION}/examinee/organization`,
        method: RequestEnum.GET,
        params,
        options: {
          noTransform: true,
          tenantId,
        },
      });
    },
    // 获取指定机构详情（根据机构code）
    getOrganizationByCode: (code: string, tenantId: string) => {
      return axios({
        url: `${ORGANIZATION}/examinee/organization/code/${code}`,
        method: RequestEnum.GET,
        options: {
          noTransform: true,
          tenantId,
        },
      });
    },
    // 获取所有单位
    getUnit: (params: any, tenantId: string) => {
      return axios({
        url: `${ORGANIZATION}/examinee/organization/${params.id}/unit`,
        method: RequestEnum.GET,
        params,
        options: {
          noTransform: true,
          tenantId,
        },
      });
    },
    getInfomation: () => {
      return axios({
        url: `${FILEDINFO}/examinee/informationItem/GetAllInformationItemAsync`,
        method: RequestEnum.GET,
      });
    },
    // 获取指定流程审核环节的审核结果
    auditResult: (workflowId: any) => {
      return axios({
        url: `${EXAMINEE}/workflowRecord/${workflowId}/auditResult`,
        method: RequestEnum.GET,
      });
    },
    // 考生端 其他模块调用机构下拉框信息
    getOrgDropDownList: (tenantId, params?: any) => {
      return axios({
        url: `${ORGANIZATION}/examinee/organization/dorpdownList`,
        method: RequestEnum.GET,
        params,
        options: { tenantId },
      });
    },
    // 考生端 根据考点代码查询考点详情
    getExamSiteDetail: (code: string, tenantId: string) => {
      return axios<ExamSite>({
        url: `${ORGANIZATION}/examinee/examSite/examSiteCode/${code}`,
        method: RequestEnum.GET,
        options: {
          noTransform: true,
          tenantId,
        },
      });
    },
    // 考生端 根据考场代码查询考场详情
    getExamPlaceDetail: (code: string) => {
      return axios({
        url: `${ORGANIZATION}/examinee/examPlace/examPlaceCode/${code}`,
        method: RequestEnum.GET,
      });
    },
    // 考生端 根据科目代码获取科目详情
    getSubjectDetailByCode: (code: string, tenantId: string) => {
      return axios<ExamCode>({
        url: `${subject}/examinee/subject/code/${code}`,
        method: RequestEnum.GET,
        options: {
          noTransform: true,
          tenantId,
        },
      });
    },
    // 获取随机码图片和校验密文（新）
    GetGraph() {
      return axios({
        url: `${SCOREQUERYSERVICE}/VerificationCodeService/GetGraph`,
        method: RequestEnum.GET,
      });
    },
    // 获取随机码图片 /api/RandomVerificationCodeService/RandomVerificationCode/{randomMark}
    getRandomVerificationCode(randomMark: string) {
      return axios({
        url: `${SCOREQUERYSERVICE}/RandomVerificationCodeService/RandomVerificationCode/${randomMark}`,
        method: RequestEnum.GET,
      });
    },
    // 获取随机码图片和校验密文
    getRandomVerificationCodeMd5(randomMark: string) {
      return axios({
        url: `${SCOREQUERYSERVICE}/RandomVerificationCodeService/RandomVerification/${randomMark}`,
        method: RequestEnum.GET,
      });
    },
    // 查询考生成绩信息
    getScoreDetailBysecurityCode: (securityCode: any, tenantId: string) => {
      return axios<ExamineeQueryScoreData>({
        url: `${SCOREQUERYSERVICE}/ExamineeScoreDataService/QrcodeQueryScoreData/${securityCode}`,
        method: RequestEnum.GET,
        options: {
          noTransform: true,
          tenantId,
        },
      });
    },
  },
  POST: {
    // 获取参与的考试id列表以及当前所处的环节等信息
    async getExamRelativeInfos(idCard: string, ids: string[]) {
      let list = await axios<ParticipateExamsModel[]>({
        url: `${EXAMINEE}/ExamineeExtremityExamineeService/ParticipateExams/${idCard}`,
        method: RequestEnum.POST,
        options: {
          noTransform: true,
        },
        data: ids,
      });

      if (list.length) {
        list = list.map((item) => {
          item["idCard"] = idCard;
          const tenantId = item.examId;
          store.commit("SET_USER_OPERATION_EXAMMAP", {
            tenantId: tenantId,
            data: { participateExams: item },
          });
          return item;
        });
      }
      return list;
    },
    // 考生端 职位自动审核
    positionAudit(data: any, tenantId: string) {
      return axios({
        url: `${ORGANIZATION}/examinee/position`,
        method: RequestEnum.POST,
        options: {
          noTransform: true,
          tenantId,
        },
        data,
      });
    },
    // 考生端 根据Id获取数据字典
    getDictByGUID(data: any) {
      return axios({
        url: `${DICTIONARYAPI}/ExamineeDictionaries/ByIds`,
        method: RequestEnum.POST,
        data,
      });
    },
    // execl批量导入考生信息
    import(data: any) {
      return axios({
        url: `${EXAMINEE}/import`,
        method: RequestEnum.POST,
        data,
      });
    },
    // 创建单个考生信息(新增按钮)
    addRecord(data: any) {
      return axios({
        url: `${EXAMINEE}`,
        method: RequestEnum.POST,
        data,
      });
    },
    // 考生端根据身份证号码查询考生成绩
    async postScoreDetailById(data: any, tenantId: string) {
      const examineeQueryScoreData = await axios<ExamineeQueryScoreData>({
        url: `${SCOREQUERYSERVICE}/ExamineeScoreDataService/ExamineeQueryScoreData`,
        method: RequestEnum.POST,
        data,
        options: {
          noTransform: true,
          tenantId: tenantId,
        },
      });
      // store.commit("SET_USER_OPERATION_EXAMMAP", {
      //   tenantId: tenantId,
      //   data: { examineeQueryScoreData },
      // });
      return examineeQueryScoreData;
    },
    // 根据考试id集合获取查询成绩时间
    async postExamListInfoById(data: any) {
      const list = await axios<ExamListInfoModel[]>({
        url: `${SCOREQUERYSERVICE}/ExamineeScoreQuerySetting/ExamListInfo`,
        method: RequestEnum.POST,
        data,
        options: {
          noTransform: true,
        },
      });
      return list;
    },
    // 验证滑动
    verificationSlide(data) {
      return axios<boolean>({
        url: `${SCOREQUERYSERVICE}/VerificationCodeService/VerificationSlide`,
        method: RequestEnum.POST,
        data,
        options: {
          noTransform: true,
        },
      });
    },
  },
  PATCH: {
    printExaminee: (params: any) => {
      return axios({
        url: `${EXAMINEE}/exam/${params.examineeId}/print/${params.workflowId}`,
        method: RequestEnum.PATCH,
      });
    },
    // 考生端 改报职位
    changePosition: (id: string, data: any, tenantId: string) => {
      return axios({
        url: `${EXAMINEE}/ExamineeExtremityExamineeService/ChangeExamineePosition/${id}`,
        method: RequestEnum.PATCH,
        data,
        options: {
          noTransform: true,
          tenantId,
        },
      });
    },
  },
};
const adminWorkFlow = {
  GET: {},
  PUT: {},
};
export default { ExamInfo, adminWorkFlow };
